import type { RouteObject } from "react-router-dom";

import { PartnerDetailPage } from "./partner-detail-page";
import { PartnersPage } from "./partners-page";

export const partnersRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Partners" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      { index: true, element: <PartnersPage /> },
      {
        path: ":partnerId",
        handle: { breadcrumb: "Partner" },
        element: <PartnerDetailPage />,
      },
    ],
  },
];
